import React from 'react';
import { Label } from 'semantic-ui-react';

import WarningMessage from '@modules/common/components/banners/WarningMessage';
import { styled } from '@modules/common/components/ThemeProvider/utils';

import { OAuthClientDescriptor } from '../../../components/types/oauth-client';
import { isAllowedOriginSet, allOriginsAllowed } from '../utils';

type Props = {
  client: OAuthClientDescriptor;
};

function SPAInfo({ client }: Props) {
  if (!client.isSPAEnabled) {
    return null;
  }
  return (
    <>
      <StyledAllowedOrigins>
        <b>Allowed origins:</b>{' '}
        {allOriginsAllowed(client.parameters.allowedWebOrigins) ? (
          <Label basic>All origins allowed</Label>
        ) : !isAllowedOriginSet(client.parameters.allowedWebOrigins) ? (
          <Label basic>No origins allowed</Label>
        ) : (
          client.parameters.allowedWebOrigins?.map((origin, i) => (
            <Label key={i} basic>
              {origin}
            </Label>
          ))
        )}
      </StyledAllowedOrigins>
      <WarningMessage>Client is set up to be used by a single-page application!</WarningMessage>
    </>
  );
}

export default SPAInfo;

const StyledAllowedOrigins = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 2px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 0.5rem;
`;
